module.exports = __webpack_public_path__ + "img/ELLY_Logo_als_Pfad.a071f95f.svg";